(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('bcmBiaProfileFullPartEditController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        $scope.ctrlCtxt.initBoxModel = _.cloneDeep($scope.boxModel);

        // Save Changes
        $scope.saveChanges = function () {
            $scope.onBoxModelSaveChanges($scope.form);
        };
    }

})();